module.exports = __webpack_public_path__ + "img/icon_ordotype.9bfe4d17.png";